export default defineNuxtPlugin((app) => {
	const vue_fb = {} as { install: (vue: unknown, options: unknown) => void };
	const scriptId = "facebook-jssdk";
	vue_fb.install = function install(_Vue: unknown, options: unknown) {
		const fjs = document.getElementsByTagName("script")[0];
		if (document.getElementById(scriptId)) return;
		const js = document.createElement("script") as HTMLScriptElement;
		js.id = scriptId;
		js.src = "//connect.facebook.net/en_US/sdk.js";
		if (fjs && fjs.parentNode) {
			fjs.parentNode.insertBefore(js, fjs);
		}

		(window as unknown as { fbAsyncInit: () => void; FB: unknown }).fbAsyncInit = function onSDKInit() {
			const FB = (
				window as unknown as {
					FB: {
						init: (options: unknown) => void;
						AppEvents: { logPageView: () => void };
					};
				}
			).FB;
			FB.init(options);
			FB.AppEvents.logPageView();
			app.provide("FB", FB);
		};
	};

	app.vueApp.use(vue_fb, {
		appId: useRuntimeConfig().public.facebook.appId,
		autoLogAppEvents: true,
		xfbml: true,
		version: "v15.0",
	});
});
